import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { getMapStopLayerIds } from "@catchy/region-config";
export const buildStopIconExpression = (isDark, preferSatellite, favourites, minVisibleZoom = 13) => {
  const suffix = isDark || preferSatellite ? "dark" : "light";
  const safeFavourites = Array.isArray(favourites) ? favourites : [];
  return ["step", ["zoom"], "", minVisibleZoom, ["case", ["in", ["get", "stop_id"], ["literal", safeFavourites]], `favourite-star-${suffix}`,
  // TODO: Remove the cableCar fallback after deployed stop GeoJSON has fully moved to cable_car.
  ["in", ["get", "stop_type"], ["literal", ["cable_car", "cableCar"]]], `cable-car-stops-col-${suffix}`, ["==", ["get", "stop_type"], "ferry"], `ferry-wharfs-col-${suffix}`, ["==", ["get", "stop_type"], "train"], `train-station-col-${suffix}`, `bus-stop-col-${suffix}`]];
};
export default function useStopIcons(map, isMapStyleLoaded, isDark, preferSatellite, favourites, t0) {
  const $ = _c(15);
  const minVisibleZoom = t0 === undefined ? 13 : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getMapStopLayerIds();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    stops: mapStopsLayerId
  } = t1;
  let t2;
  if ($[1] !== favourites || $[2] !== isDark || $[3] !== isMapStyleLoaded || $[4] !== map.current || $[5] !== minVisibleZoom || $[6] !== preferSatellite) {
    t2 = () => {
      if (map.current && isMapStyleLoaded) {
        if (!map.current.getLayer(mapStopsLayerId)) {
          return;
        }
        const expression = buildStopIconExpression(isDark, preferSatellite, favourites, minVisibleZoom);
        map.current.setLayoutProperty(mapStopsLayerId, "icon-image", expression);
      }
    };
    $[1] = favourites;
    $[2] = isDark;
    $[3] = isMapStyleLoaded;
    $[4] = map.current;
    $[5] = minVisibleZoom;
    $[6] = preferSatellite;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== favourites || $[9] !== isDark || $[10] !== isMapStyleLoaded || $[11] !== map || $[12] !== minVisibleZoom || $[13] !== preferSatellite) {
    t3 = [favourites, isDark, isMapStyleLoaded, map, mapStopsLayerId, minVisibleZoom, preferSatellite];
    $[8] = favourites;
    $[9] = isDark;
    $[10] = isMapStyleLoaded;
    $[11] = map;
    $[12] = minVisibleZoom;
    $[13] = preferSatellite;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  useEffect(t2, t3);
}